import React, { Component } from 'react'

import DropdownMenu from 'components/dropdown-menu/dropdown-menu'
import AutosizeInput from 'react-input-autosize'

import copy from 'fast-copy'

import isEqual from 'react-fast-compare'

export default class TagsInput extends Component {
    state = {
        inputValue: ''
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        const propsToCompare = {
            ...this.props,
            onChange: null
        }

        const newPropsToCompare = {
            ...nextProps,
            onChange: null
        }

        if(isEqual(propsToCompare, newPropsToCompare) && isEqual(this.state, nextState)){
            return false
        }
        
        return true
    }

    changeTextInput = e => {
        this.setState({
            inputValue: e.target.value
        })

        e.stopPropagation()
        e.preventDefault()
    }

    handleClickInput = _ => {
        this.focusInput()
    }

    focusInput = _ => {
        if(this.refs.input){
            this.refs.input.focus()
        }
    }

    selectTag = tagId => {
        const tagObject = this.props.existingTags.find(existingTag => {
            return existingTag.id == tagId
        })

        const {
            value
        } = copy(this.props)

        if(tagObject){
            value.push(tagObject.name ? tagObject.name : tagObject.organisation_name)

            this.props.onChange(value)

            this.setState({
                inputValue: ''
            }, _ => {
                this.focusInput()
            })
        }
    }

    addNewTag = _ => {
        const {
            inputValue
        } = this.state

        const {
            value
        } = copy(this.props)

        if(!value.includes(inputValue)){
            value.push(inputValue)
        }

        this.props.onChange(value)

        this.setState({
            inputValue: ''
        }, _ => {
            this.focusInput()
        })
    }

    removeTag = tag => {
        const {
            value
        } = copy(this.props)

        const tagIndex = value.findIndex(tempTag => {
            return tempTag == tag
        })

        if(tagIndex !== -1){
            value.splice(tagIndex, 1)
        }

        this.props.onChange(value)
    }

    getSelectableItems = _ => {
        const {
            existingTags,
            value
        } = this.props

        const {
            inputValue
        } = this.state

        const selectableItems = []

        existingTags.forEach(tag => {
            let tagName = null

            if(tag.name){
                tagName = tag.name
            }else if(tag.organisation_name){
                tagName = tag.organisation_name
            }

            if(tagName && value.indexOf(tagName) == -1 && inputValue && tagName.toLowerCase().includes(inputValue.toLowerCase())){
                selectableItems.push(tag)
            }
        })

        return selectableItems
    }

    render(){
        const {
            inputValue,
        } = this.state

        const {
            parentType,
            value,
            valueKey,
            placeholder = `Enter ${parentType}s...`,
            disabled
        } = this.props

        let inputValueIfUnique = inputValue

        if(!inputValue || value.indexOf(inputValue) !== -1){
            inputValueIfUnique = null
        }

        const selectableItems = this.getSelectableItems()

        let className = 'input-tags'

        if(disabled){
            className += ' disabled'
        }
        
        return (
            <div className={className}>
                <div 
                    className="input-standard"
                    onClick={this.handleClickInput}
                >
                    <ul className="tags-list">
                        { value.map((tag, index) => {
                            return (
                                <li key={index}>
                                    <span>
                                        { tag }
                                    </span>
                                    { !disabled ?
                                    <button 
                                        type="button"
                                        onClick={e => {this.removeTag(tag, e)}}
                                    >
                                        &times;
                                    </button>
                                    : null }
                                </li>
                            )
                        })}
                        { !disabled ? 
                        <AutosizeInput
                            placeholder={!value.length ? placeholder : ''}
                            value={inputValue}
                            onChange={this.changeTextInput}
                            ref="input"
                        />
                        : null }
                    </ul>
                </div>
                { !disabled ?
                <DropdownMenu 
                    isObjects={true} 
                    selectableItems={selectableItems} 
                    selectedItemId={null} 
                    handleChange={this.selectTag} 
                    parentType={parentType}
                    canAddNew={true}
                    newItemValue={inputValueIfUnique}
                    addNewCallback={this.addNewTag}
                    isForcedOpen={(inputValueIfUnique || selectableItems.length)}
                    valueKey={valueKey}
                />
                : null }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/input/tags.jsx